@use "styles/abstracts/mixins/common" as c;
@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/variables" as v;

$divider-color: v.$palette-gray-200;

.cardsWrapper {
  height: 100%;
  overflow-y: auto;
}

.cardWrapper {
  padding: 0 16px;
}

.airCard {
  margin-bottom: 8px; 
}

.opened-card {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  @include c.hide-scrollbar;
}

.tabs-row {
  flex-grow: 1;
  align-items: flex-start;
  overflow-y: hidden;
}

.change-shipping-line-row {
  margin: 16px 0;
}

.tabs {
  height: 100%;
  width: 100%;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.tabsControls {
  margin-bottom: 20px;
  border-bottom: 1px solid $divider-color;
}

.tabs-body {
  width: 100%;
  margin-top: 0;
  overflow-y: auto;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  @include c.custom-scrollbar($width: 8px);
}

.panel {
  flex-grow: 1;
}

.vessels-panel {
  display: flex;
  flex-direction: column;
}

.divider {
  border-top: 1px solid $divider-color;
}

.bottom-actions {
  padding-top: 14px;
  margin-top: auto;
  align-items: center;
}

.linkButton {
  line-height: 0;
}

.loader {
  margin: 50px auto;
}

.actionsContainer {
  display: flex;
  gap: 8px;
  margin-left: auto;

  .follow {
    @include t.text(14px, 22px, 500);
    padding: 5px 14px;
  }

  .delete,
  .linkButton {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    width: 32px;
    height: 32px;
    background-color: v.$palette-blue-light-2;
  }

  .delete svg,
  .linkButton svg {
    path {
      fill: v.$palette-blue;
    }
  }

  .linkButton {
    line-height: 0;
  }
}

.tooltipButtonsText {
  @include t.text($fontSizePX: 12px, $fontWeight: 600);
  background-color: v.$palette-blue;
  color: v.$palette-blue-light;
  padding: 5px;
  border-radius: 5px;
  width: max-content;
}